import React, { useState } from "react";

export default function Enroll() {
  const [form, setForm] = useState({ email: "", name: "", phone: "" });
  const [done, setDone] = useState(false);
  const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const onSubmit = e => {
    e.preventDefault();
    setDone(true);
  };

  return (
    <section className="enroll" id="contact">
      <div className="container enroll__grid">
        <div className="enroll__left">
          <h3 className="enroll__steps">3 Steps To Enroll Now</h3>
          <ol className="enroll__list">
            <li>Book a free consultation. Get your personalized study plan.</li>
            <li>Join a cohort or self-paced track that fits your timeline.</li>
            <li>Get result-oriented training with full support.</li>
          </ol>
        </div>
        <div className="enroll__right">
          <div className="enroll__logo">
            <span className="logo__bull"></span>
            <span className="logo__text">The Bulls Trading Academy</span>
          </div>
          {!done ? (
            <form action="https://formsubmit.co/info@thebullstrading.com" method="POST" className="enroll__form">
  
            {/* <!-- User Email (sender) --> */}
            <input 
              type="email" 
              name="email" 
              placeholder="Email Address" 
              required 
            />
          
            {/* <!-- Full Name --> */}
            <input 
              type="text" 
              name="name" 
              placeholder="Full Name" 
              required 
            />
          
            {/* <!-- Phone Number --> */}
            <input 
              type="text" 
              name="phone" 
              placeholder="Phone" 
              required 
            />

           <input 
              type="hidden" 
              name="_autoresponse" 
              value="✅ Thanks for joining The Bulls Trading Academy! We’ve received your request and will contact you shortly." 
            />
          
            <button className="btn btn--primary" type="submit">Join Now</button>
          
            <p className="enroll__hint">
              By joining, you agree to receive course information on the provided contact.
            </p>
          </form>
          
          ) : (
            <div className="enroll__thanks">
              <h4>Thanks! We will reach out shortly.</h4>
              <p>You’ll receive an email with next steps and a calendar link.</p>
            </div>
          )}
        </div>
      </div>
      
<a rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"/>


  <a href="https://wa.me/923306886537" className="whatsapp" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="currentColor">
    <path d="M16.001 2.667c-7.364 0-13.334 5.97-13.334 13.334 0 2.353.617 4.643 1.787 6.66L2.667 29.333l6.91-1.8A13.26 13.26 0 0 0 16 29.333c7.364 0 13.334-5.97 13.334-13.333 0-7.364-5.97-13.334-13.333-13.334Zm0 24c-2.18 0-4.31-.567-6.166-1.64l-.44-.259-4.097 1.067 1.093-3.99-.287-.454a10.647 10.647 0 0 1-1.653-5.387c0-5.882 4.781-10.667 10.667-10.667 5.882 0 10.667 4.785 10.667 10.667S21.883 26.667 16.001 26.667Zm5.838-8.108c-.319-.159-1.887-.931-2.179-1.037-.293-.106-.506-.159-.72.16s-.825 1.037-1.013 1.252c-.187.213-.373.24-.692.08-.319-.159-1.348-.497-2.567-1.585-.95-.847-1.59-1.892-1.776-2.211-.187-.32-.02-.493.14-.652.144-.143.319-.373.479-.559.16-.187.213-.319.32-.533.107-.213.054-.4-.027-.56-.08-.16-.72-1.733-.987-2.373-.26-.624-.52-.54-.72-.55-.187-.007-.4-.009-.613-.009a1.178 1.178 0 0 0-.853.4c-.293.32-1.12 1.094-1.12 2.667s1.147 3.093 1.306 3.307c.16.213 2.253 3.44 5.467 4.813.76.327 1.353.52 1.814.667.763.243 1.456.21 2.004.127.612-.091 1.887-.77 2.154-1.514.267-.747.267-1.387.187-1.514-.08-.133-.293-.213-.613-.373Z"/>
  </svg>
</a>


    </section>
  );
}
